import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';
import { Box } from '../Box';
import { pxToRem } from '../../styles/utils';

import { Size } from '../../data/featuredPress';

export const SocialProofContainer = styled('div')`
  display: flex;
  flex-direction: column;
  ${mediaQueries.tablet} {
    flex-direction: column-reverse;
  }
`;

export const PressItem = styled(Box)<{ rowIdx: number; multiplier: Size }>`
  height: ${pxToRem(59)};
  display: flex;
  flex-direction: column;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: ${pxToRem(59)};
  }

  ${({ theme, rowIdx = 1, multiplier: { mobile = 1, desktop = 1 } }) => `
    ${mediaQueries[0]} {
      width: calc(25% * ${mobile});
      margin: ${rowIdx > 1 ? `${pxToRem(8)} 0` : theme.spacing.s};
    }

    ${mediaQueries.min} {
      width: calc(25% * ${mobile});
      margin: ${rowIdx > 1 ? `${pxToRem(8)} 0` : theme.spacing.s};
    }
    
    ${mediaQueries.tablet} {
      width: calc(12% * ${desktop});
      margin: 0;
    }  
  `}
}
`;

export const StarImage = styled('img')`
  margin: ${({ theme }) => theme.spacing.xs};
  display: inline-block;
  width: 35px;
  width: ${pxToRem(35)};

  ${mediaQueries.tablet} {
    margin: ${({ theme }) => theme.spacing.s};
    width: ${pxToRem(45)};
  }
`;

export const SocialProofText = styled('div')`
  max-width: 500px;
  margin: auto;
  text-align: center;
`;
